// returns true if this plan has a quantity control
// planObject equals the Plan database model
export function planHasQuantity (planObject) {
  if (!planObject) return false;
  if (planObject.billingScheme === 'tiered') return false;
  return planObject.type === 'connector';
}
